import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { PageName } from '../types';

interface IContainerDataState {
  // State
  videoId: number;
  userId: number;
  pageName: PageName;
  isInitialized: boolean;

  // Actions
  setVideoId: (videoId: number) => void;
  setUserId: (userId: number) => void;
  setPageName: (pageName: PageName) => void;
  initialize: (videoId: number, pageName: PageName) => void;
  reset: () => void;
}

const initialStoreState: {
  videoId: number;
  userId: number;
  pageName: PageName;
  isInitialized: boolean;
} = {
  videoId: 0,
  userId: 0,
  pageName: 'single_video_view_manage',
  isInitialized: false,
};

export const useContainerDataStore = create<IContainerDataState>()(
  devtools(
    (set, get) => ({
      // Initial State
      ...initialStoreState,

      // Actions
      setVideoId: (videoId) => set(() => ({ videoId }), undefined, 'containerData/setVideoId'),
      setUserId: (userId) => set(() => ({ userId }), undefined, 'containerData/setUserId'),
      setPageName: (pageName) => set(() => ({ pageName }), undefined, 'containerData/setPageName'),
      initialize: (videoId, pageName) => {
        // Only initialize if not already initialized
        if (!get().isInitialized) {
          set(
            () => ({ videoId, pageName, isInitialized: true }),
            undefined,
            'containerData/initialize',
          );
        }
      },
      reset: () => set(() => initialStoreState, undefined, 'containerData/reset'),
    }),
    {
      name: 'ContainerDataStore',
      enabled: process.env.NODE_ENV !== 'production' && typeof window !== 'undefined',
    },
  ),
);
